import { queryOptions } from "@tanstack/react-query";

import { getSubscription, type SubscriptionDetail } from "@/lib/api/billing";

// ─── Query keys ───────────────────────────────────────────────────────────────

export const billingKeys = {
  all: ["billing"] as const,
  subscription: () => [...billingKeys.all, "subscription"] as const,
};

// ─── Query options ────────────────────────────────────────────────────────────

export const subscriptionQueryOptions = () =>
  queryOptions({
    queryKey: billingKeys.subscription(),
    queryFn: getSubscription,
    staleTime: 60 * 1000, // 1 minute
  });

export type { SubscriptionDetail };
